import { render, staticRenderFns } from "./op-detail.vue?vue&type=template&id=3bad0b54&scoped=true"
import script from "./op-detail.vue?vue&type=script&lang=js"
export * from "./op-detail.vue?vue&type=script&lang=js"
import style0 from "./op-detail.vue?vue&type=style&index=0&id=3bad0b54&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bad0b54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bad0b54')) {
      api.createRecord('3bad0b54', component.options)
    } else {
      api.reload('3bad0b54', component.options)
    }
    module.hot.accept("./op-detail.vue?vue&type=template&id=3bad0b54&scoped=true", function () {
      api.rerender('3bad0b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/compliance/contractManager/dialog/op-detail.vue"
export default component.exports